/**
 * @desc 物流覆盖区域更新
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsChannelZoneUpdateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/zone/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
